<template>
  <div class="banner-form">
    <el-dialog :title="titleType"
               :visible.sync="privateDialogVisible"
               width="600px"
               @close="update">
      <el-form ref="form"
               :model="form"
               label-width="120px">
        <el-form-item label="标题：">
          <el-input v-model="form.banner_title"
                    placeholder="请输入banner标题"></el-input>
        </el-form-item>

        <el-form-item label="banner图：">
                       <UploadCover
                       :img_width="200"
                       :img_height="100"
                       @uploadSuccess="uploadSuccess"
                       :coverImg="form.banner_cover"></UploadCover>
        </el-form-item>
        
        <el-form-item label="添加链接：">
          <!-- <p>选择链接类型及链接（可不添加）</p> -->
          <div class="seach-list">
            <el-select class="input-v l"
                       v-model="form.link_mode"
                       clearable
                       placeholder="请选择类型"
                       @change="getType">
              <el-option v-for="(item,index) in options"
                         :key="index"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
            <el-select v-model="form.original_links"
                       clearable
                       filterable
                       remote
                       reserve-keyword
                       :remote-method="remoteMethod"
                       placeholder="搜索课程或者是专题的名字"
                       class="input-sea"
                       @change="getValue">
              <el-option v-for="(item,index) in linkOptions"
                         :key="index"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer tc">
        <el-button @click="privateDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="sendBanner()">发 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { _allCourseList, _allTopicList } from "@/api/section-links.js";

import UploadCover from "@/components/single-upload.vue";

import { _bannerSave, _bannerSort } from "@/api/interface.js";

import qs from "qs";

//初始化信息
const FORM_INFO = function () {
  return {
    banner_title: "",
    banner_cover: "",
    original_links: "",
    link_mode: 1
  };
};
export default {
  created () {
    this.initCouresList();
  },
  components: {
    UploadCover
  },
  props: {
    bannerVisible: {
      type: Boolean,
      default: false
    },
    banner_info: {
      type: Object,
      default: null
    },
    banner_type: {
      type: String
    },
    isEdit: {
      type: Boolean,
    }
  },
  watch: {
    bannerVisible (val) {
      this.privateDialogVisible = val;
    },
    isEdit (val) {
      // console.log(val);
    },
    banner_info (val) {
      if (this.isEdit) {
        for (const key in this.form) {
          this.form[key] = this.banner_info[key];
        }
        this.form.banner_id = this.banner_info.banner_id;
      }
    }
  },
  computed: {
    //用户列表的私人消息，和用户的消息列表的全员消息和私人列表的的区分
    titleType () {
      if (this.banner_type == 1) {
        return "新增banner";
      } else if (this.banner_type == 2) {
        return "编辑banner";
      }
    },
  },
  data () {
    return {
      privateDialogVisible: false,
      form: FORM_INFO(),
      linkOptions: [],
      options: [
        {
          value: 1,
          label: "课程"
        },
        {
          value: 2,
          label: "专题"
        }
      ],
      roleOptions: []
    };
  },
  methods: {
    update () {
      this.form = FORM_INFO();
      this.$emit("update:bannerVisible", false);
    },
    getType (val) {
      this.form.original_links = "";
      if (val == 1) {
        this.form.link_mode = 1;
        this.initCouresList();
      } else if (val == 2) {
        this.form.link_mode = 2;
        this.initTopicList();
      } else {
        this.form.link_mode = null;
        this.linkOptions = [];
      }
    },
    getValue (val) {
      console.log(val);
      this.linkOptions.some(_ => {
        if (_.value == val) {
          this.form.banner_title = _.label
          return true
        }
      })
    },
    //实时远程搜索链接地址
    remoteMethod (query) {
      if (this.form.link_mode == 1) {
        this.initCouresList(query);
      } else if (this.form.link_mode == 2) {
        this.initTopicList(query);
      } else {
        this.linkOptions = [];
      }
    },
    //上传图片
    uploadSuccess (url) {
      this.form.banner_cover = url;
    },
    //加载课程的列表
    initCouresList (query) {
      query ? query : query = ""
      _allCourseList({
        params: {
          link_mode: 1,
          keywords: query
        }
      }).then(res => {
        if (res.resultCode == 1) {
          let data = res.result.list;
          this.linkOptions = data.map(item => {
            return {
              label: item.course_name,
              value: item.link
            };
          });
          // console.log(this.linkOptions);
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    //加载专题的列表
    initTopicList (query) {
      query ? query : query = ""
      _allTopicList({
        params: {
          link_mode: 1,
          keywords: query
        }
      }).then(res => {
        if (res.resultCode == 1) {
          let data = res.result.list;
          this.linkOptions = data.map(item => {
            return {
              label: item.topic_name,
              value: item.link
            };
          });
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    //发送消息
    sendBanner () {
      // console.log(this.form);
      _bannerSave({
        data: qs.stringify(this.form)
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.$emit("updateList", true);
        } else {
          this.$message.error(res.errorMsg);
        }
      });
      this.privateDialogVisible = false;
    }
  }
};
</script>


<style lang="less" scoped>
.seach-list {
  display: flex;
  .input-v {
    flex: 0.8;
  }
  .input-sea {
    flex: 1.1;
    margin-left: 30px;
  }
}
</style>
